import { drawAllergyCard, type CardModel } from "./drawCard";

function saveBlob(blob: Blob, name: string) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url; anchor.download = name;
  document.body.append(anchor); anchor.click(); anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}

export async function exportAllergyCard(model: CardModel, width: number, pageIndex: number, format: "pdf" | "png") {
  if (!model.entries.length || model.entries.some(entry => entry.primary === "…")) throw new Error("incomplete_card");
  const canvas = document.createElement("canvas");
  const initial = await drawAllergyCard(canvas, model, width, pageIndex);
  const filename = `docio-allergy-card-${model.source}-${model.target}`;
  if (format === "png") {
    const blob = await new Promise<Blob>((resolve, reject) => canvas.toBlob(value => value ? resolve(value) : reject(new Error("png_failed")), "image/png"));
    saveBlob(blob, `${filename}-${initial.pageIndex + 1}.png`);
    return;
  }
  const { jsPDF } = await import("jspdf");
  const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  for (let index = 0; index < initial.pages.length; index++) {
    if (index > 0) pdf.addPage();
    await drawAllergyCard(canvas, model, width, index);
    const imageHeight = model.format === "wallet" ? 108 : 265;
    const imageWidth = model.format === "wallet" ? 86 : imageHeight * initial.width / initial.height;
    pdf.addImage(canvas.toDataURL("image/png"), "PNG", (210 - imageWidth) / 2, 12, imageWidth, imageHeight, undefined, "FAST");
  }
  saveBlob(pdf.output("blob"), `${filename}.pdf`);
}
